import { gsap } from "gsap";

class CounterNums {
    constructor(el) {
        this.el = el;
        this.finalNumber = el.dataset.counterNum;
        this.time = el.dataset.counterTime || 2
        this.separator = el.dataset.counterSeparator || '';
        if(!this.finalNumber) return;

        this.valueEl = el.querySelector('span');
        this.init();
    }

    init() {
        this.valueEl.innerHTML = '0';
    }

    run() {
        setTimeout(() => {
            let target = { val: 0 };
            gsap.to(target, {
                duration: this.time,
                val: this.finalNumber,
                onUpdate: () => {
                    let val = target.val.toFixed(0);
                    if(this.separator) {
                        val = val.replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
                    }

                    this.valueEl.innerHTML = val
                },
                onComplete: () => {
                    let val = `${target.val}`;
                    if(this.separator) {
                        val = val.replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
                    }

                    this.valueEl.innerHTML = val;
                }
            });
        }, 250)
    }
}

export default CounterNums
